<div class="card">
  <div class="card-body">

    <form #frmConfigCaixa="ngForm" (ngSubmit)="onSubmitConfigCaixa()">

      <div class="alert alert-success" role="alert" *ngIf="mensagemSucessoCaixa">
        <i class="mdi mdi-check-all mr-2"></i> {{mensagemSucessoCaixa}}
      </div>

      <div class="alert alert-blue mb-2">
        <b>Módulo Caixa</b>
        <div class="mt-1">
          <small class="form-text text-muted">
            O módulo <b>Caixa</b> permite controlar abertura/fechamento de caixa, sangrias/suprimentos, controle de operador
            e consolidar movimentações do dia com mais rastreabilidade.
          </small>
        </div>
      </div>

      <!-- ATIVAR / DESATIVAR -->
      <div class="form-group" *ngIf="false">
        <label>Módulo CAIXA ativo</label>
        <div class="mt-0 mb-1 font-24 valor">
          <kendo-switch
            name="caixaAtivo"
            [(ngModel)]="configCaixa.ativo"
            [onLabel]="'Sim'"
            [offLabel]="'Não'">
          </kendo-switch>
        </div>

        <small class="form-text text-muted">
          Se desabilitado, as rotinas de caixa (abertura/fechamento e movimentações) ficam indisponíveis.
        </small>
      </div>

      <!-- MODO DE OPERAÇÃO -->
      <div class="ml-1 mt-2" [ngClass]="{'text-muted': !configCaixa.ativo}">
        <label>Modo de operação</label>

        <div class="ui-g-12 mt-1">
          <label class="k-radio-label" for="modoCaixaOperador">
            <input
              type="radio"
              id="modoCaixaOperador"
              name="modoOperacaoCaixa"
              class="k-radio"
              [(ngModel)]="configCaixa.modoOperacao"
              [value]="'OPERADOR'"
              [disabled]="!configCaixa.ativo" />
            &nbsp;Caixa por operador
          </label>

          <div class="ml-4">
            <small class="form-text text-muted">
              Cada operador abre e fecha seu próprio caixa. Ideal para turnos, múltiplos atendentes e conferência individual.
            </small>
          </div>
        </div>

        <div class="ui-g-12 mt-2">
          <label class="k-radio-label" for="modoCaixaUnico">
            <input
              type="radio"
              id="modoCaixaUnico"
              name="modoOperacaoCaixa"
              class="k-radio"
              [(ngModel)]="configCaixa.modoOperacao"
              [value]="'UNICO'"
              [disabled]="!configCaixa.ativo" />
            &nbsp;Caixa único
          </label>

          <div class="ml-4">
            <small class="form-text text-muted">
              Um único caixa por loja/PDV. Ideal para operação simples com um fechamento consolidado no fim do dia.
            </small>
          </div>
        </div>

        <div class="alert alert-light mt-2" *ngIf="configCaixa.ativo">
          <small class="form-text text-muted mb-0">
            <b>Dica:</b> Se você tem mais de um atendente revezando no caixa, use <b>Caixa por operador</b>.
            Se o caixa é “o da loja”, use <b>Caixa único</b>.
          </small>
        </div>
      </div>


      <div class="alert alert-info mt-2" *ngIf="configCaixa.ativo">
        <i class="mdi mdi-information-outline mr-2"></i>
        <small class="form-text text-muted mb-0">
          <b>Pedidos Online:</b> Independentemente do modo de operação escolhido
          (Caixa por operador ou Caixa único), os <b>pedidos realizados online</b>
          são lançados automaticamente em um <b>caixa separado</b>, devido à sua
          natureza independente da operação manual do estabelecimento.
          <br><br>
          Isso garante maior controle e separação entre vendas presenciais e vendas digitais.
        </small>
      </div>


      <div class="mt-3 ml-1">
        <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="salvando">
          Salvar
        </button>
      </div>

    </form>
  </div>
</div>
